(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-collection-faq"] && !Shopify.designMode) return;
  try {
    
  function bindCollectionFaqAccordion(root = document) {
    root.querySelectorAll('.obor-collection-faq__list').forEach((list) => {
      if (list.dataset.faqAccordionBound === 'true') return;
      list.dataset.faqAccordionBound = 'true';

      list.addEventListener(
        'click',
        (event) => {
          const summary = event.target.closest('summary');
          if (!summary || !list.contains(summary)) return;

          const detail = summary.parentElement;
          if (!(detail instanceof HTMLDetailsElement) || !detail.classList.contains('obor-faq-item')) {
            return;
          }

          event.preventDefault();

          const shouldOpen = !detail.open;

          list.querySelectorAll('details.obor-faq-item').forEach((item) => {
            item.open = false;
          });

          if (shouldOpen) {
            detail.open = true;
          }
        },
        true
      );
    });
  }

  bindCollectionFaqAccordion();

  document.addEventListener('shopify:section:load', (event) => {
    bindCollectionFaqAccordion(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["obor-product-landing"] && !Shopify.designMode) return;
  try {
    
  function bindOborPdpFaqAccordion(root = document) {
    root.querySelectorAll('[data-obor-pdp-faq-list]').forEach((list) => {
      if (list.dataset.faqAccordionBound === 'true') return;
      list.dataset.faqAccordionBound = 'true';

      list.addEventListener(
        'click',
        (event) => {
          const summary = event.target.closest('summary');
          if (!summary || !list.contains(summary)) return;

          const detail = summary.parentElement;
          if (!(detail instanceof HTMLDetailsElement) || !detail.classList.contains('obor-pdp-landing__faq-item')) {
            return;
          }

          event.preventDefault();

          const shouldOpen = !detail.open;

          list.querySelectorAll('details.obor-pdp-landing__faq-item').forEach((item) => {
            item.open = false;
          });

          if (shouldOpen) {
            detail.open = true;
          }
        },
        true
      );
    });
  }

  bindOborPdpFaqAccordion();

  document.addEventListener('shopify:section:load', (event) => {
    bindOborPdpFaqAccordion(event.target);
  });

  } catch(e) { console.error(e); }
})();
})();
